<script setup lang="ts">
  import { InfiniteScrollView, Pagination } from '@/shared/ui';
  import type { NotificationResponse } from '@/shared/lib';
  import type { NotificationItemsPerPage } from '../model/types';

  defineProps<{
    notifications: NotificationResponse[];
    itemsPerPage: NotificationItemsPerPage;
    totalItems: number;
    currentPage: number;
    loadingMore?: boolean;
    hasMoreItems?: boolean;
  }>();

  defineEmits<{
    'page-changed': [page: number];
  }>();
</script>

<template>
  <InfiniteScrollView
    v-if="itemsPerPage === 'all'"
    :all-items="notifications"
    :metadata="{ total: totalItems }"
    :loading-more="loadingMore ?? false"
    :has-more-items="hasMoreItems ?? false"
    entity-name="notificação"
  />
  <Pagination
    v-else-if="notifications.length > 0"
    :total-items="totalItems"
    :items-per-page="Number(itemsPerPage)"
    :current-page="currentPage"
    entity-name="notificação"
    @page-changed="$emit('page-changed', $event)"
  />
</template>
